import React from "react";

const Footer = () => {
   return (
      <div
         className="p-5  "
         style={{ textAlign: "center", backgroundColor: "black" }}
      >
         <span className="fav-style">
            <a href="https://github.com/bakhtiarabid" target="_blank">
               <i
                  style={{ color: "#C0C0C0" }}
                  class="fab fa-github p-2 rounded-3 fs-5"
               ></i>
            </a>
         </span>
         <span className="fav-style">
            <a
               href="https://www.linkedin.com/in/bakhtiar-abid-3a902215b/"
               target="_blank"
            >
               <i
                  style={{ color: "#C0C0C0" }}
                  class="fab fa-linkedin-in p-2 rounded-3 fs-5 ms-2"
               ></i>
            </a>
         </span>
         <span className="fav-style">
            <a href="https://twitter.com/abidwx" target="_blank">
               <i
                  style={{ color: "#C0C0C0" }}
                  class="fab fa-twitter p-2 rounded-3 fs-5 ms-2"
               ></i>
            </a>
         </span>
         <span className="fav-style">
            <a href="https://www.facebook.com/babid2/" target="_blank">
               <i
                  style={{ color: "#C0C0C0" }}
                  class="fab fa-facebook p-2 rounded-3 fs-5 ms-2"
               ></i>
            </a>
         </span>
         <span className="fav-style">
            <a
               href="https://mail.google.com/mail/u/0/?fs=1&to=bakhtiar.abid2@gmail.com&tf=cm"
               target="_blank"
            >
               <i
                  style={{ color: "#C0C0C0" }}
                  class="fab far fa-envelope p-2 rounded-3 fs-5 ms-2"
               ></i>
            </a>
         </span>
         <p className="py-2" style={{ color: "#C0C0C0" }}>
            Developed by{" "}
            <a href="https://github.com/bakhtiarabid">
               <span className="text-primary">Bakhtiar Abid</span>
            </a>{" "}
            <br />
            Copyright © 2022, All Rights Reserved
         </p>
      </div>
   );
};

export default Footer;
